module.exports = __webpack_public_path__ + "static/media/typescript.e7ef5555.svg";